export const actionTypes = {
  SHOW_LIMITED_FEATURES_DIALOG: 'SHOW_LIMITED_FEATURES_DIALOG',
  HIDE_LIMITED_FEATURES_DIALOG: 'HIDE_LIMITED_FEATURES_DIALOG',
};

// Pass-through on purpose: the reducer spreads the payload over initialState,
// so a whitelist here silently drops any new option (paywall was lost this way).
const showLimitedFeaturesDialog = (options = {}) => ({
  type: actionTypes.SHOW_LIMITED_FEATURES_DIALOG,
  payload: options,
});

const hideLimitedFeaturesDialog = () => ({
  type: actionTypes.HIDE_LIMITED_FEATURES_DIALOG,
});

export { showLimitedFeaturesDialog, hideLimitedFeaturesDialog };
